// extracted by mini-css-extract-plugin
export var fill = "sprites-module--fill--6f480";
export var sprite = "sprites-module--sprite--2035e";